/**
 * created by panjm on 2019-10-14
 *
 * description： 左侧菜单模块
 *
 */

import utils from 'libs/utils.js';
import LeftTpl from './module/left.dot';
import consts from 'consts';

export default class Left {
	/**
	 * description： 构造函数
	 * @param {Object} 属性集合
	 *
	 * created by panjm on 2019-10-24
	 *
	 */
	constructor(options) {
		this.options = options || {};
		// 初始化html容器
		this.leftContainer = $('#left');
		// 解决图片等在不同目录下的地址问题
		this.dpath = utils.getDpath(this.options.level);
		// 权限按钮
		this.btnAuths = this.options.btnAuths;
	}

	/**
	 * description： 渲染左侧内容
	 *
	 * created by panjm on 2019-10-24
	 *
	 */
	render() {
		let menus = [{
			name: '审批中心',
			children: [{
				name: '审批处理',
				url: 'handle/index.html',
				show: this.btnAuths[consts.AUTHS.BTN_AUTH['审批处理-查看']]
			},
			{
				name: '我提交的审批',
				url: 'mine/index.html',
				show: this.btnAuths[consts.AUTHS.BTN_AUTH['我提交的审批-查看']]
			},
			{
				name: '审批设置',
				url: 'setting/index.html',
				show: this.btnAuths[consts.AUTHS.BTN_AUTH['审批设置-查看']]
			}]
		}];

		menus.forEach((item) => {
			item.children = item.children.filter(child => child.show === true);
		});
		// 模版数据
		let data = {
			dpath: this.dpath,
			curUrl: window.location.href,
			menu: menus
		};

		this.leftContainer.html(utils.replacePath(LeftTpl(data)));

		// 事件绑定
		this.bindEvent();
	}

	/**
	 * description： 事件绑定
	 *
	 * created by panjm on 2019-10-24
	 *
	 */
	bindEvent() {
		let that = this;

		//【菜单】跳转事件绑定
		$('body').on('click', '.spzx_leftmenu li', function(){
			let url = $(this).data('url');

			// 跳转地址
			utils.href(url);
		});

		// 展开/收起事件
		$('body').on('click', '.spzx_leftmenu h5', function(){
			// 获取父级容器
			let parentContainer = $(this).parents('.menu_block');

			// 修改父级类名

			// 修改图标旋转角度
			$(this).find('i').toggleClass('on');

			// 切换列表显示/隐藏
			parentContainer.find('ul').slideToggle();
		});

	}
}


// WEBPACK FOOTER //
// ./src/template/dot/layout/left/index.js